"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithPresenceFeature = void 0;
var PresenceRepository_1 = require("./PresenceRepository");
var PresenceRequests_1 = require("./PresenceRequests");
// Because we can get messages about clients before the client register is initialized, we have this "backlog" of callbacks within this
// feature that is used to store and run inbound message handlers after the call to initialize the register is made.  This kind of thing
// comes into play when an update is sent by another client just as we connect so we get the update before we have initialized.  Or, another
// possibility is that in between the fetch_register and reply_register we receive another message such as a notify_join.  To deal with this
// we queue the calls and ensure that the handlers are all "re-runable", e.g. they don't fail if they find their effect already applied.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WithPresenceFeature(Base) {
    return /** @class */ (function (_super) {
        __extends(PresenceFeature, _super);
        function PresenceFeature() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
            _this.backlog = [];
            _this.inClientJoin = function (_a) {
                var _b = __read(_a, 1), clientId = _b[0];
                _this.whenRegisterReady(function () {
                    // If already registered, ignore
                    if (_this.register.has(clientId))
                        return;
                    var ref = _this.createRef(clientId);
                    _this.register.add(ref);
                    _this.router.emit('clientJoin', ref);
                });
            };
            _this.inClientLeave = function (_a) {
                var _b = __read(_a, 1), clientId = _b[0];
                _this.whenRegisterReady(function () {
                    // If not registered, ignore
                    if (!_this.register.has(clientId))
                        return;
                    var ref = _this.createRef(clientId);
                    _this.register.delete(ref.id);
                    _this.router.emit('clientLeave', ref);
                });
            };
            _this.inClientUpdate = function (_a) {
                var _b = __read(_a, 3), clientId = _b[0], puts = _b[1], dels = _b[2];
                _this.whenRegisterReady(function () {
                    // If not registered, ignore
                    if (!_this.register.has(clientId))
                        return;
                    _this.register.update(clientId, puts, dels);
                    var affectedKeys = puts.map(function (x) { return x[0]; }).concat(dels);
                    _this.flushClientUpdate(clientId, affectedKeys);
                });
            };
            _this.pod.receive('notify_join', _this.inClientJoin);
            _this.pod.receive('notify_leave', _this.inClientLeave);
            _this.pod.receive('notify_profile', _this.inClientUpdate);
            _this.onInit(_this.presenceStart);
            return _this;
        }
        PresenceFeature.prototype.getClients = function () {
            return this.register.getClients();
        };
        PresenceFeature.prototype.getClient = function (clientId) {
            return this.register.getClient(clientId);
        };
        PresenceFeature.prototype.getClientProfile = function (clientId) {
            return this.register.getProfile(clientId);
        };
        PresenceFeature.prototype.getClientProfileValue = function (clientId, key) {
            return this.register.getProfileValue(clientId, key);
        };
        PresenceFeature.prototype.getThisClientProfile = function () {
            return this.register.getProfile(this.pod.clientId);
        };
        PresenceFeature.prototype.getThisClientProfileValue = function (key) {
            return this.register.getProfileValue(this.pod.clientId, key);
        };
        PresenceFeature.prototype.patchProfile = function (patch) {
            if (this.destroyed())
                return;
            if (this.readonly)
                return;
            var _a = __read(this.processProfilePatch(patch), 3), affectedKeys = _a[0], puts = _a[1], dels = _a[2];
            if (!affectedKeys.length)
                return;
            var reductionKey = affectedKeys.join('/');
            this.register.update(this.pod.clientId, puts, dels);
            this.pod.send('update_profile', [puts, dels], reductionKey);
            this.flushClientUpdate(this.pod.clientId, affectedKeys);
        };
        PresenceFeature.prototype.on = function (type, to) {
            return this.router.on(type, to);
        };
        PresenceFeature.prototype.presenceStart = function () {
            return __awaiter(this, void 0, void 0, function () {
                var data, mapped;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.pod.request((0, PresenceRequests_1.fetchPresenceData)())];
                        case 1:
                            data = _a.sent();
                            mapped = data.map(function (_a) {
                                var _b = __read(_a, 2), id = _b[0], pr = _b[1];
                                return [_this.createRef(id), pr];
                            });
                            this.register = new PresenceRepository_1.PresenceRepository(mapped);
                            // Flush the backlog
                            this.backlog.forEach(function (x) { return x(); });
                            this.backlog = [];
                            return [2 /*return*/];
                    }
                });
            });
        };
        PresenceFeature.prototype.flushClientUpdate = function (clientId, affectedKeys) {
            var info = this.getClient(clientId);
            var profile = this.getClientProfile(clientId);
            this.router.emit('clientUpdate', [info, profile, affectedKeys]);
        };
        PresenceFeature.prototype.processProfilePatch = function (patch) {
            var e_1, _a;
            var puts = [];
            var dels = [];
            var keys = Object.keys(patch);
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var k = keys_1_1.value;
                    if (patch[k] === null || patch[k] === undefined || Number.isNaN(patch[k]) || patch[k] === Infinity) {
                        dels.push(k);
                    }
                    else {
                        puts.push([k, patch[k]]);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return [keys, puts, dels];
        };
        PresenceFeature.prototype.whenRegisterReady = function (callback) {
            if (this.register) {
                callback();
            }
            else {
                this.backlog.push(callback);
            }
        };
        return PresenceFeature;
    }(Base));
}
exports.WithPresenceFeature = WithPresenceFeature;
